import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { SharedModule } from '../../shared.module';
import { ImageButtonComponent } from './image-button.component';

@NgModule({
  declarations: [
    ImageButtonComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,

    NzAvatarModule,
    NzImageModule,
    NzIconModule
  ],
  exports: [
    ImageButtonComponent
  ]
})
export class ImageButtonModule {}
